"use client";
import { sendGTMEvent } from "@/components/Analytics";
import Newsletter from "@/components/Cards/Newsletter";
import Slider from "@/components/Carousel/Slider";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Testimonial from "@/components/Text/Testimonial";
import Title from "@/components/Text/Title";
import Triangles from "@/components/Triangles";
import { CardMdNoButton } from "@/stories/Card.stories";
import { NewsletterYellow } from "@/stories/Newsletter.stories";
import { Testemonial, TestemonialOrange } from "@/stories/Testemonial.stories";

export default function MechanischeGrundsatzeLayout() {
    const mechanischen = [
        {
            title: "Keine Energieübertragung",
            content:
                "Jeder besitzt ein einzigartiges Energiefeld. Störungen durch fremde Energien können es schaden. Die Lösung liegt in der Stärkung des eigenen Energiefelds.",
            img: "/images/symptoms1.png",
            buttonText: "Mehr dazu",
        },
        {
            title: "Eigene Heilungsgeschwindigkeit",
            content:
                "Nachhaltiger Aufbau des Energiefelds erfordert Geduld und Beachtung des individuellen Heilungstempos. Schnelle Veränderungen sind nicht anhaltend.",
            img: "/images/symptoms2.png",
            buttonText: "Mehr dazu",
        },
        {
            title: "Arbeit an den Ursachen",
            content:
                "Uns belastende Symptome spiegeln verletzte Energiefelder wider. Nur eine gezielte Ursachenbehandlung löst diese Symptome dauerhaft.",
            img: "/images/symptoms3.png",
            buttonText: "Mehr dazu",
        },
    ];
    return (
        <>
            <div className="bg-pink flex  justify-center">
                <div className="container w-full md:px-20  px-3  pb-10 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Worum geht's: die mechanischen grundsätze"
                        title="Jedes Energiefeld hat seine eigene Logik"
                        hasSubTitle={false}
                        text="Diese muss man erkennen, um individuell arbeiten zu können"
                        paddings="px-3 pt-30 "
                    />
                    <PlayerInPage
                        videoId="362fac87c8b7a1645a709ce839c12aea"
                        thumbnail="/images/thumbnails/mechanisheThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-pink">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full  px-3 lg:px-20 flex-col justify-center items-center gap-6 inline-flex">
                    <Testimonial
                        backgroundColor={Testemonial.args?.backgroundColor}
                        description={Testemonial.args?.description}
                        hasDescription={Testemonial.args?.hasDescription}
                        hasImage={Testemonial.args?.hasImage}
                        icon={Testemonial.args?.icon}
                        name={Testemonial.args?.name}
                        textColor={Testemonial.args?.textColor}
                        text={Testemonial.args?.text}
                        wordsInDifferentColor={Testemonial.args?.wordsInDifferentColor}
                        differentTextColor={Testemonial.args?.differentTextColor}
                        textSizes={Testemonial.args?.textSizes}
                    />
                </div>
            </div>

            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>

            <div className="bg-black w-full  px-6 lg:px-16 py-20 flex-col gap-6 inline-flex">
                <div className="text-left md:text-center lg:text-center text-white text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14 flex justify-center">
                    Die 3 wichtigsten mechanischen Grundsätze
                </div>

                <div className="hidden md:hidden lg:flex gap-6" />
                <div className="container px-10">
                    <div className="lg:hidden">
                        <Slider
                            slideContnent={mechanischen}
                            paginationColor="#fff"
                            contentEl={CardMdNoButton}
                            slidesToShow={1}
                        />
                    </div>
                    <div className="hidden lg:block">
                        <Slider
                            slideContnent={mechanischen}
                            paginationColor="#fff"
                            contentEl={CardMdNoButton}
                            slidesToShow={3}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-black">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise w-full px-3 lg:px-16 py-20 flex-col justify-center items-center gap-6 inline-flex">
                <PlayerInPage
                    videoId="d0fd81fb8490cb37f19249273aa13a94"
                    thumbnail="/images/thumbnails/mechanisheThumbnail2.jpg"
                />
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-orange" buttomToTop={true} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full  px-3 lg:px-16 flex-col justify-center items-center gap-6 inline-flex">
                    <Testimonial
                        backgroundColor={TestemonialOrange.args?.backgroundColor}
                        description={TestemonialOrange.args?.description}
                        differentTextColor={TestemonialOrange.args?.differentTextColor}
                        hasDescription={TestemonialOrange.args?.hasDescription}
                        name={TestemonialOrange.args?.name}
                        text={TestemonialOrange.args?.text}
                        wordsInDifferentColor={
                            TestemonialOrange.args?.wordsInDifferentColor
                        }
                        textColor={TestemonialOrange.args?.textColor}
                    />
                </div>
            </div>

            <div className="bg-orange">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full  px-3  flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterYellow.args?.backgroundColor}
                        buttonText="HOL DIR DIE MASTERCLASS"
                        hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                        hasDescription={NewsletterYellow.args?.hasDescription}
                        hasInput={NewsletterYellow.args?.hasInput}
                        hasSubText={NewsletterYellow.args?.hasSubText}
                        buttonAs="a"
                        href="/de/masterclass#masterclassSection"
                        paddings="px-3 py-25 lg:px-96 lg:py-25 md:px-20"
                        title="Willst du mehr erfahren?"
                        description="Ich lade dich herzlich zu meiner Videosammlung Masterclass ein. Hier dreht sich alles um das faszinierende Thema Energiefelder. Es ist mir wichtig, dass jeder die Möglichkeit hat, von diesem Wissen zu profitieren."
                        buttonPaddings="lg:px-10 px-2 py-4"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Willst du mehr erfahren?",
                                section_index: "6",
                                cta_text: "HOL DIR DIE MASTERCLASS",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
        </>
    );
}
